import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { WorkOrder } from '../WorkOrder'

/**
 * Arguments for updating serial numbers on a work order item.
 * Used during work order planning to select which serial numbers will be consumed.
 */
@InputType()
export class UpdateWorkOrderItemSerialNumbersArgs extends ActionArgs {
  @Field(() => ID)
  workOrderId: string

  @Field(() => ID)
  workOrderItemId: string

  @Field(() => [ID])
  inventoryBySerialNumberIds: string[]
}

export interface IUpdateWorkOrderItemSerialNumbers extends IAction<WorkOrder, UpdateWorkOrderItemSerialNumbersArgs> {}
